import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { FEATURES } from 'collaboration-sidebar/constants/features';
import { useUserInfo } from 'collaboration-sidebar-common/userInfo/userInfoQueries';
export default function useHasSidebarPermission(t0) {
  "use memo";

  const $ = _c(8);
  const {
    appHub,
    enabledFeatures
  } = t0;
  const {
    hasScopeForHub
  } = useUserInfo();
  let t1;
  bb0: {
    if (!enabledFeatures) {
      t1 = false;
      break bb0;
    }
    const hasComments = enabledFeatures.includes(FEATURES.COMMENTS) || enabledFeatures.includes(FEATURES.DEEP_COMMENTING);
    if (!hasComments) {
      t1 = true;
      break bb0;
    }
    if (!appHub) {
      t1 = false;
      break bb0;
    }
    if (Array.isArray(appHub)) {
      let t2;
      if ($[0] !== appHub || $[1] !== hasScopeForHub) {
        let t3;
        if ($[3] !== hasScopeForHub) {
          t3 = hub => hasScopeForHub(hub);
          $[3] = hasScopeForHub;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = appHub.find(t3);
        $[0] = appHub;
        $[1] = hasScopeForHub;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = Boolean(t2);
      break bb0;
    }
    let t2;
    if ($[5] !== appHub || $[6] !== hasScopeForHub) {
      t2 = hasScopeForHub(appHub);
      $[5] = appHub;
      $[6] = hasScopeForHub;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = t2;
  }
  return t1;
}